import React, { useEffect, useRef, useState } from "react";
import NavBar from "../communs/NavBar";
import { AppDispatch, RootState } from "../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import headerBg from "../../assets/background/InternBanner2.png";
import headerMobileBg from "../../assets/images/MVCases.png";
import HeroSectionDetailsProject from "./layout-details-project/HeroSectionDetailsProject";
import ComposedCard from "../../biblio/Cards/ComposedCard";
import PaginationComponent from "../../biblio/Pagination/PaginationComponent";
import Loader from "../../biblio/Loader/Loader";
import FooterSection from "../../components/sections/FooterSection";
import pray from "../../assets/icons/SelectIcon.svg";

import {
  getAllCompletedKorba,
  getAllKorba,
  getAllKorbaAssistance,
  getAllKorbaTypes,
} from "../../apis/actions/korba.actions";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import { LeftOutlined } from "@ant-design/icons";
import TransparentButton from "../../biblio/Buttons/TransparentButton";
import { ConfigProvider, Empty, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import { scroll } from "../../components/utils/utils";
const { Search } = Input;

const itemPerPage = 8;
const Korbas = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();
  const korbas = useSelector((state: RootState) => state?.korbas?.korbas);
  const korbaTypes = useSelector(
    (state: RootState) => state?.korbas?.korbaTypes
  );
  const korbaAssitances = useSelector(
    (state: RootState) => state?.korbas?.korbaAssitances
  );
  const completedKorba = useSelector(
    (state: RootState) => state?.korbas?.completedkorba
  );

  const currentRef = useRef<HTMLDivElement>(null);

  const [active, setActive] = useState<number>(1);
  const [loading, setLoading] = useState(true);
  const [projectName, setProjectName] = useState("");
  const [filteredKorba, setFilteredKorba] = useState<any[]>(korbas);
  const [isCompleted, setIsCompleted] = useState<boolean>(false);
  const [selectedAssistance, setSelectedAssistance] = useState(null);

  useEffect(() => {
    dispatch(getAllKorba());
    dispatch(getAllKorbaTypes());
    dispatch(getAllKorbaAssistance());
    dispatch(getAllCompletedKorba());
  }, [dispatch]);

  useEffect(() => {
    setFilteredKorba(isCompleted ? completedKorba : korbas);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [korbas, completedKorba]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [korbas]);

  const updateActive = (nb: number) => {
    setActive(nb);
    scroll(currentRef);
  };

  const onSearch = (
    selectedProjectType: any,
    projectName: string,
    isCompleted?: boolean
  ) => {
    setActive(1);
    if (selectedProjectType === null && projectName === "") {
      setFilteredKorba(isCompleted ? completedKorba : korbas);
      return;
    }

    const filtered = isCompleted
      ? completedKorba.filter(
          (project: any) =>
            (!selectedProjectType ||
              project.assistance_id === selectedProjectType) &&
            (!projectName || project.summary.includes(projectName))
        )
      : korbas.filter(
          (project: any) =>
            (!selectedProjectType ||
              project.assistance_id === selectedProjectType) &&
            (!projectName || project.summary.includes(projectName))
        );

    setFilteredKorba(filtered);
  };

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  const updateIsCompleted = () => {
    if (isCompleted) {
      setIsCompleted(false);
      setFilteredKorba(korbas);
      onSearch(selectedAssistance, projectName, false);
    } else {
      setActive(1);
      setIsCompleted(true);
      setFilteredKorba(completedKorba);
      onSearch(selectedAssistance, projectName, true);
    }
  };

  return (
    <div className="takaful--projects-container">
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="الرئيسية"
        subTitle="الحالات"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
        type={"تفريج كرب"}
      />
      <div
        className="takaful--cases-section"
        style={{ marginTop: "2vh" }}
        ref={currentRef}
      >
        <div className="takaful--cases-header">
          <div className="takaful--cases-header-content">
            <div className="takaful--cases-header-box">
              <img src={pray} alt="" />
              <ConfigProvider
                renderEmpty={() => (
                  <Empty
                    description={
                      <span className="takaful--select-empty">
                        لا توجد بيانات
                      </span>
                    }
                  />
                )}
              >
                <Select
                  key="22"
                  showSearch
                  popupMatchSelectWidth={300}
                  className={`takaful--select takaful--selects`}
                  size="large"
                  placeholder="اختر نوع الخدمة"
                  onChange={(e) => {
                    e
                      ? setSelectedAssistance(
                          korbaAssitances.filter((el: any) => el.id === e)[0]
                            .name
                        )
                      : setSelectedAssistance(null);
                  }}
                  options={[
                    ...korbaAssitances.map((option: any) => ({
                      label: option.name,
                      value: option.id,
                    })),
                  ]}
                  dropdownRender={(menu) => (
                    <div className="takaful--select-dropdown">{menu}</div>
                  )}
                  allowClear
                  onClear={() => {
                    onSearch(null, projectName, isCompleted);
                  }}
                />
              </ConfigProvider>
            </div>
            <Search
              className="takaful--search"
              placeholder="ادخل كلمة البحث"
              allowClear
              enterButton
              onPressEnter={() => {
                onSearch(selectedAssistance, projectName, isCompleted);
              }}
              onClear={() => onSearch(selectedAssistance, "", isCompleted)}
              type="text"
              onChange={(e) => setProjectName(e.target.value)}
            />
            <PrimaryButton
              className="takaful--primary-button"
              icon={<LeftOutlined />}
              title={t("cases.button")}
              onClick={() =>
                onSearch(selectedAssistance, projectName, isCompleted)
              }
            />
            <TransparentButton
              className="takaful--completed-button"
              title={isCompleted ? "كرب تنتظر دعمكم" : "المكتملة"}
              onClick={() => updateIsCompleted()}
            />
          </div>
        </div>
      </div>
      <div>
        <div className="takaful--cases-section">
          <div className="takaful--cases" style={{ marginTop: "4vh" }}>
            {filteredKorba.length > 0 &&
              filteredKorba
                .slice(itemPerPage * (active - 1), itemPerPage * active)
                .map((project: any, index: number) => (
                  <ComposedCard
                    type="تفريج كرب"
                    project={project}
                    donation_type_ids={korbaTypes}
                    cardClass={"card-1"}
                    isCompleted={isCompleted}
                  />
                ))}
          </div>
        </div>
      </div>
      {filteredKorba && filteredKorba.length > itemPerPage && (
        <PaginationComponent
          active={active}
          scroll={() => scroll(currentRef)}
          total={filteredKorba.length}
          itemPerPage={itemPerPage}
          setActive={(nb) => updateActive(nb)}
        />
      )}
      <FooterSection />
    </div>
  );
};

export default Korbas;
